<div class="container-fluid d-flex h-100 justify-content-center align-items-center">
  <div class="row">
    <div class="location-col col-4">
      <form>
        <mat-form-field>
          <mat-label>{{'PAGE_LOCATION.CHOOSE_LOCATION'| translate}}</mat-label>
          <input type="text" aria-label="Choose a location" matInput [formControl]="selectedLocation"
            [matAutocomplete]="auto" autofocus #location>
          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="locationSelected()"
            [displayWith]="displayFn">
            @for (option of (filteredLocations | async) ?? []; track option) {
            <mat-option [value]="option">
              {{ option.name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </div>
  </div>
</div>